import React from "react";
import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex flex-col justify-center overflow-hidden pt-20 sm:pt-24 lg:pt-16"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center mb-8 sm:mb-12 lg:mb-16">
          <div className="flex flex-col space-y-4 sm:space-y-5 lg:space-y-6 text-center lg:text-left order-2 lg:order-1">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-foreground leading-tight px-2 sm:px-0">
              Unlock the Future with <span className="text-accent">AI</span>
            </h1>

            <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-foreground font-medium px-2 sm:px-0">
              Transforming Possibilities into Reality!
            </p>

            <p className="text-base sm:text-lg text-muted-foreground max-w-xl mx-auto lg:mx-0 px-2 sm:px-0">
              Transform your digital reality with cutting-edge artificial
              intelligence. Build powerful voice agents that handle calls,
              automate conversations, and scale your business effortlessly.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-2 sm:pt-4 justify-center lg:justify-start px-2 sm:px-0">
              <Link
                to="/signup"
                className="px-6 sm:px-8 py-2.5 sm:py-3 bg-accent text-accent-foreground font-medium rounded-md hover:opacity-90 transition-opacity text-sm sm:text-base w-full sm:w-auto text-center"
              >
                Get Started
              </Link>
            </div>
          </div>

          <div className="flex items-center justify-center lg:justify-end order-1 lg:order-2">
            <div className="relative w-full max-w-sm sm:max-w-md lg:max-w-lg h-[300px] sm:h-[400px] md:h-[500px] lg:h-[600px] group">
              <img
                src="/ai-hero.png"
                alt="Futuristic AI Robot"
                className="w-full h-full object-contain brightness-90 dark:brightness-100 contrast-110 dark:contrast-100 animate-float transition-all duration-300 group-hover:scale-105 group-hover:brightness-110 dark:group-hover:brightness-110"
                onMouseEnter={(e) => {
                  e.target.style.animation =
                    "float-hover 4s ease-in-out infinite";
                }}
                onMouseLeave={(e) => {
                  e.target.style.animation = "float 6s ease-in-out infinite";
                }}
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextElementSibling.style.display = "block";
                }}
              />
              <svg
                className="w-full h-full object-contain hidden animate-float transition-all duration-300 group-hover:scale-105"
                onMouseEnter={(e) => {
                  e.target.style.animation =
                    "float-hover 4s ease-in-out infinite";
                }}
                onMouseLeave={(e) => {
                  e.target.style.animation = "float 6s ease-in-out infinite";
                }}
                viewBox="0 0 400 500"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="150"
                  y="50"
                  width="100"
                  height="120"
                  rx="10"
                  className="fill-gray-200 dark:fill-gray-300"
                />
                <rect
                  x="170"
                  y="70"
                  width="20"
                  height="20"
                  rx="5"
                  className="fill-gray-800 dark:fill-gray-900"
                />
                <rect
                  x="210"
                  y="70"
                  width="20"
                  height="20"
                  rx="5"
                  className="fill-gray-800 dark:fill-gray-900"
                />
                <rect
                  x="180"
                  y="110"
                  width="40"
                  height="10"
                  rx="5"
                  className="fill-gray-800 dark:fill-gray-900"
                />

                <path
                  d="M 140 50 Q 200 20, 260 50 L 250 170 Q 200 190, 150 170 Z"
                  className="fill-gray-400 dark:fill-gray-500"
                />

                <rect
                  x="180"
                  y="170"
                  width="40"
                  height="80"
                  className="fill-gray-800 dark:fill-gray-900"
                />

                <circle cx="200" cy="200" r="3" fill="#16a34a" />
                <circle cx="200" cy="220" r="3" fill="#16a34a" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
